import { View } from "ui/atoms/view";
import { useState } from "react";
import CreateBodyMapEntryForm from "./CreateBodyMapEntryForm";
import { BodyMap } from "../organisms/BodyMap";
import UpdateBodyMapEntryForm from "./UpdateBodyMapEntryForm";

interface Props {
  residentId?: number;
  entryId?: number;
  locations?: string[];
  onClose: () => void;
}

export default function BodyMapEntryTemplate({
  residentId,
  entryId,
  locations,
  onClose,
}: Props) {
  const [selectedParts, setSelectedParts] = useState<string[]>([]);

  return (
    <View className="gap-2">
      <BodyMap
        selectedParts={locations || selectedParts}
        onChange={setSelectedParts}
      ></BodyMap>
      {residentId && entryId ? (
        <UpdateBodyMapEntryForm
          residentId={residentId}
          entryId={entryId}
          onClose={onClose}
        />
      ) : (
        <CreateBodyMapEntryForm
          selectedBodyParts={selectedParts}
          onClose={onClose}
        />
      )}
    </View>
  );
}
